// Onboarding topic questions. Selecting a topic seeds its tag at weight 1.0 in
// the interest vector (see feed/interest.ts). Tags here must match the tag
// vocabulary the enrichment LLM emits onto articles.

export interface TopicOption {
  tag: string;
  label: string;
}

export interface TopicQuestion {
  id: string;
  prompt: string;
  options: TopicOption[];
}

export const TOPIC_QUESTIONS: TopicQuestion[] = [
  {
    id: "domains",
    prompt: "Which subjects pull you in?",
    options: [
      { tag: "technology", label: "Technology" },
      { tag: "science", label: "Science" },
      { tag: "business", label: "Business" },
      { tag: "health", label: "Health" },
      { tag: "politics", label: "Politics" },
    ],
  },
  {
    id: "culture",
    prompt: "Anything on the lighter side?",
    options: [
      { tag: "sports", label: "Sports" },
      { tag: "entertainment", label: "Entertainment" },
      { tag: "gaming", label: "Gaming" },
      { tag: "food", label: "Food" },
      { tag: "travel", label: "Travel" },
    ],
  },
  {
    id: "world",
    prompt: "How wide should we cast the net?",
    options: [
      { tag: "world", label: "World news" },
      { tag: "local", label: "Local" },
      { tag: "climate", label: "Climate" },
      { tag: "economy", label: "Economy" },
    ],
  },
];

/** Every tag offered across the questions (handy for tests). */
export function allTopicTags(): string[] {
  return TOPIC_QUESTIONS.flatMap((q) => q.options.map((o) => o.tag));
}
